/**
 * @generated SignedSource<<a4fb94860b841a4b5cf4ed84f6e7cce9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutItemPanel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDescriptionAdditionalOptions_user" | "PdpRespDetails_user">;
  readonly " $fragmentType": "PdpRespAboutItemPanel_user";
};
export type PdpRespAboutItemPanel_user$key = {
  readonly " $data"?: PdpRespAboutItemPanel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutItemPanel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptions_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetails_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4e45456f6bb2ed17c87a7f13e57d8da5";

export default node;
